import { Content } from '@orobix/orobix-fe-components'
import { FormikErrors } from 'formik'
import { useTranslation } from 'react-i18next'

import PageHeader from '../../components/PageHeader/PageHeader'
import SearchForm, { SearchFormValues } from './SearchForm'

const SearchRoot = () => {
  const { t } = useTranslation()

  return (
    <Content>
      <PageHeader title={t('Training search')} />

      <SearchForm<SearchFormValues>
        initialValues={{
          uuid: '',
        }}
        validate={(values) => {
          const errors: FormikErrors<{ [field: string]: string }> = {}

          if (!values.uuid) {
            errors.uuid = t('This field is required')
          }

          return errors
        }}
        onSubmit={(values) => true}
      />
    </Content>
  )
}

export default SearchRoot
